import { useState } from 'react';

interface Later<Data> {
  data: Data | undefined;
  error: Error | undefined;
  promise: Promise<Data>;
  done(d: Data | undefined, error: Error | undefined): void;
}

function laterPromise<Data>(): Later<Data> {
  let done: (d: Data | undefined, e: Error | undefined) => void;
  const promise = new Promise<Data>((resolve, reject) => {
    done = (data, error) => {
      result.done = (data, error) => {
        result.data = data;
        result.error = error;
        if (error) {
          result.promise = Promise.reject(error);
          // Catch the error to avoid a possible unhandled rejection
          result.promise.catch(() => {});
        } else {
          result.promise = Promise.resolve(data!);
        }
      };
      result.data = data;
      result.error = error;
      if (error) {
        reject(error);
      } else {
        resolve(data!);
      }
    };
  });
  const result: Later<Data> = {
    data: undefined,
    error: undefined,
    promise,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    done,
  };
  return result;
}

export function usePromise<Data>() {
  const [promise] = useState(() => laterPromise<Data>());
  return promise;
}
